import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-mobile-pay-setup",
	templateUrl: "./mobile-pay-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class MobilePaySetupComponent implements OnInit, OnDestroy {
	changesToSave: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	timestamp;

	viewMode: number = 0;

	constructor(public app: AppService, private localStorage: LocalDataStoreService, public imgCrop: ImageCropperService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {}

	ngOnDestroy() {}

	async onSave() {
		try {
			await this.venueSvc.ooVenueSave(this.venueSvc.ooVenue);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `MobilePay settings saved successfully.` });
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Error saving MobilePay settings.` });
		}
	}

	updateTimestamp() {
		this.timestamp = new Date().getTime();
	}
}
